import { Progress } from "antd";
import classNames from "classnames";

import { ProgressBarProps } from "./ProgressBar.type";
import ProgressBarSlider from "./ProgressBarSlider";
import "./ProgressBar.style.less";

const ProgressBar = ({
  value, // 0 or [0, 0] for range
  isEditable = false,
  withBorder = false,
  style = {},
  ...sliderProps
}) => {
  return (
    <div
      className={classNames("progress-bar", {
        "-with-border": withBorder,
      })}
      style={style}
    >
      {isEditable ? (
        <ProgressBarSlider value={value} {...sliderProps} />
      ) : (
        <Progress percent={value} format={(percent) => `${percent}%`} />
      )}
    </div>
  );
};

ProgressBar.propTypes = ProgressBarProps;

export default ProgressBar;
